import React from "react";

// react-router components
import { Navigate, Routes, Route } from "react-router";

// LCM partnerPower routes - user role = partner required
import routes from "partnerPower.routes";
import PartnerPower from "./PartnerPower";

const PartnerPowerRoutes = () => {
  // const isAuthenticated = useSelector((state) => state.users.isAuthenticated);
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={<PartnerPower>{route.component}</PartnerPower>}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <Routes>
      {getRoutes(routes)}
      <Route path="*" element={<Navigate to="/partnerPower/dashboards" />} />
    </Routes>
  );
};

export default PartnerPowerRoutes;
